import DEFAULT_CSS from './default.js'

export const BUTTON_AND_DROPDOWN_CONTAINER_BLOCK = {
  key: "button-and-dropdown-container",
  template: `
    <div class="tcpa-custom-button-dropdown">
      {{>$children}}
    </div>
  `,
}
export const TITLE_BLOCK = {
  key: "title",
  template: `
    <div class="tcpa-title">
      <h2>
        {{{@question}}}
      </h2>
    </div>
  `,
}
export const CONSENT_BLOCK = {
  key: "consent",
  template: `
    <div class="tcpa-consent-text">
      <label class="tcpa-consent-label">
        <input type="hidden" id="leadid_tcpa_disclosure_{{@cfid}}"/>
        {{{@consentText}}}
      </label>
    </div>
  `,
}

export const TCPA_DROPDOWN_BLOCK = {
  key: "tcpa-dropdown",
  template: `
    {{#if @answers_dropdown}}
      <div class="tcpa-dropdown-container">
        <div class="tcpa-dropdown-content">
          <select class="tcpa-dropdown">
            <option value="">others option</option>
            {{#each @answers_dropdown}}
              <option value="{{this.key}}">{{this.answer}}</option>
            {{/each}}
          </select>
        </div>
      </div>
    {{/if}}
  `,
}

export const TCPA_BUTTONS_BLOCK = {
  key: "tcpa-buttons",
  template: `
    <div class="tcpa-answers">
      <div class="tcpa-container tcpa-answers-content" {{#if @horizontalPadding}}style="padding-left: {{@horizontalPadding}}!important;padding-right: {{@horizontalPadding}}!important;"{{/if}}>
        {{#each @rows_answers}}
          <div class="tcpa-answers-row">
          {{#each this}}
              <div class="tcpa-item-button-image tcpa-col">
                <div class="{{this.class}}">
                  <button class="tcpa-item-button
                    {{#if @buttonPadding}}
                      p-{{@buttonPadding}}
                    {{else}}
                      p-3
                    {{/if}}
                    {{#if this.imagePosition}}
                      {{#if (or (eq this.imagePosition "top") (eq this.imagePosition "bottom"))}}tcpa-vertical{{/if}}
                    {{else}}
                      tcpa-vertical
                    {{/if}}
                  " data-id="{{this.key}}" type="button" style="{{this.style}}">
                    {{#if this.imagePosition}}
                      {{#if (or (eq this.imagePosition "top") (eq this.imagePosition "left"))}}
                        {{#if this.src}}
                          <img style="{{#if this.imageHeight}}height: {{this.imageHeight}};{{/if}}{{#if this.imageWidth}}width: {{this.imageWidth}};{{/if}}" class="tcpa-item-image" src="{{this.src}}" alt="{{this.alt}}" />
                        {{/if}}
                      {{/if}}
                      <div class"tcpa-item-text">
                        {{#if @isMultipleAnswers}} <input type="checkbox" /> {{/if}}
                        {{this.answer}}
                      </div>
                      {{#if (or (eq this.imagePosition "bottom") (eq this.imagePosition "right"))}}
                        {{#if this.src}}
                          <img style="{{#if this.imageHeight}}height: {{this.imageHeight}};{{/if}}{{#if this.imageWidth}}width: {{this.imageWidth}};{{/if}}" class="tcpa-item-image" src="{{this.src}}" alt="{{this.alt}}" />
                        {{/if}}
                      {{/if}}
                    {{else}}
                      {{#if this.src}}
                        <img class="tcpa-item-image" src="{{this.src}}" alt="{{this.alt}}" />
                      {{/if}}
                      <div class"tcpa-item-text">
                        {{#if @isMultipleAnswers}} <input type="checkbox" /> {{/if}}
                        {{this.answer}}
                      </div>
                    {{/if}}
                  </button>
                </div>
              </div>
            {{/each}}
          </div>
        {{/each}}
      </div>
    </div>
  `,
}

export const CONTINUE_BUTTON_BLOCK = {
  key: "continue-button",
  template: `
    <div class="tcpa-continue-container"><button class="bt-continue" type="button" >Continue</button></div>
  `,
}

export const SKIP_BUTTON_BLOCK = {
  key: "skip-button",
  template: `
    {{#if @skipAnswer}}
      {{#unless @isMultipleAnswers}}
        <div class="tcpa-item-answer">
          <button type="button" class="tcpa-answer custom-tcpa-skip" data-id="{{@skipAnswer.key}}" style="background-color:rgba({{@skipAnswer.color}}); color:rgba({{@skipAnswer.fontcolor}});">{{@skipAnswer.answer}}</button>
        </div>
      {{/unless}}
    {{/if}}
  `,
}

const ROOT_BLOCK = {
  key: "root-page",
  template: `
    <form class="tcpa-questionary-form">
      <div class="tcpa-questionary-custom {{#if (or @required @isMultipleAnswers @manualSubmit)}}tcpa-required{{/if}}" data-question="{{@cfid}}" data-trustedform="{{@trustedformCfid}}" data-leadid="{{@leadidCfid}}" data-key="{pe_key}" data-manual-submit="{{@manualSubmit}}" data-required="{{@required}}" data-multiple="{{@isMultipleAnswers}}" data-template-type="{{@templateType}}" data-save-consent-text="{{@saveConsentText}}" data-auto-scroll-to-consent="{{@autoScrollToConsent}}">
        {{>$children}}
        <span class='invalid-feedback tcpa-required-feedback'>Please, select an option.</span>
        {{#if @leadid}}
          {{> lead-id}}
        {{/if}}
      </div>
    </form>
  `,
}

const TRUSTEDFORM_BLOCK = {
  key: 'trusted-form',
  template: ` <script type="text/javascript">
    (function() {
        var field = 'xxTrustedFormCertUrl';
        var provideReferrer = false;
        var invertFieldSensitivity = false;
        var tf = document.createElement('script');
        tf.type = 'text/javascript'; tf.async = true;
        tf.src = 'http' + ('https:' == document.location.protocol ? 's' : '') +
        '://api.trustedform.com/trustedform.js?field=' + escape(field) + '&l='+new Date().getTime()+Math.random() + '&invert_field_sensitivity=' + invertFieldSensitivity;
        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(tf, s); }
    )();
  </script>
  <noscript>
    <img src="http://api.trustedform.com/ns.gif" />
  </noscript>`,
}

const LEADID_BLOCK = {
  key: 'lead-id',
  template: `
    <input id="leadid_token" name="universal_leadid" type="hidden" value=""/>
    <script id="LeadiDscript" type="text/javascript">
      // <!--
      (function() {
      var s = document.createElement('script');
      s.id = 'LeadiDscript_campaign';
      s.type = 'text/javascript';
      s.async = true;
      s.src = '//create.lidstatic.com/campaign/{{raw '{{@system_config.jornaya.leadid_key}}'}}.js?snippet_version=2';
      var LeadiDscript = document.getElementById('LeadiDscript');
      LeadiDscript.parentNode.insertBefore(s, LeadiDscript);
      })();
      // -->
    </script>
    <noscript><img src='//create.leadid.com/noscript.gif?lac=934e3705-ae01-d5f3-9e2b-b9a54e634c7a&lck={{raw '{{@system_config.jornaya.leadid_key}}'}}&snippet_version=2' /></noscript>
  `,
}

const STYLE_BLOCK = {
  key: 'style',
  template: `
    <style>
      ${DEFAULT_CSS}
      {{@css}}
    </style>
  `,
}

export const DEFAULT_BLOCKS = [
  ROOT_BLOCK,
  TRUSTEDFORM_BLOCK,
  LEADID_BLOCK,
  STYLE_BLOCK,
]
